import { changeFilterValueToArrayOfIds, nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { FILTER_CONFIG_NAMES, FILTER_FIELD_TYPE } from './DataConstants';
import {
	FILTER_OPTIONS,
	FILTER_OPTION_KEY_BUILDERS,
	FILTER_OPTIONS_IS_AND_IS_NOT,
	filterOptionsBuilder,
} from './FilterUtils';
import OWRadioGroup from '../components/ow_radio_group/OWRadioGroup';
import RegionsLocationsTreeSelect from '../components/regions_tree_select/RegionsLocationsTreeSelect';
import ProblemTypeTreeSelect from '../components/problem_type_tree_select';

export const getPrivateNetworkFilterConfig = ({
	locations,
	problemTypes,
	fetchLocations,
	fetchProblemTypes,
	updateFilters,
	targetCollectionName,
	filterTargetCollectionName,
}: {
	locations: any;
	problemTypes: any;
	fetchLocations: any;
	fetchProblemTypes: any;
	updateFilters: (filters: any, targetCollectionName: string) => void;
	targetCollectionName: string;
	filterTargetCollectionName: string;
}) => {
	const getFilters = (filtersStateSlice) =>
		nullSafeGetOrElse(`${targetCollectionName}.filters`, filtersStateSlice, {});

	return [
		{
			fieldName: 'relationshipStatus',
			type: FILTER_FIELD_TYPE.RADIO_GROUP,
			items: [
				{ label: 'All', value: 'undefined' },
				{ label: 'Connected', value: 'Connected' },
				{ label: 'Invited', value: 'Invited' },
				{ label: 'Self Managed', value: 'SelfManaged' },
			],
			filtersValueAccessor: (filtersStateSlice) => {
				const filters = getFilters(filtersStateSlice);
				return typeof filters.relationshipStatus === 'undefined'
					? 'undefined'
					: `${filters.relationshipStatus}`;
			},
			defaultValue: undefined,
			keyAccessor: (item) => item.value,
			valueAccessor: (item) => item.value,
			handleChange: (relationshipStatus) => {
				const val = relationshipStatus
					? relationshipStatus === 'undefined'
						? undefined
						: relationshipStatus
					: undefined;
				updateFilters({ relationshipStatus: val }, targetCollectionName);
			},
			renderRecord: (item) => item.label,
			component: OWRadioGroup,
			showOutsideDropdown: true,
		},
		{
			label: 'Location',
			mode: 'multiple',
			fieldName: 'locationIds',
			stateSlice: locations,
			filtersValueAccessor: (filtersStateSlice, selectedFilterOption = FILTER_OPTIONS.IS) =>
				changeFilterValueToArrayOfIds(
					nullSafeGet(
						FILTER_OPTION_KEY_BUILDERS[selectedFilterOption]('locationIds'),
						getFilters(filtersStateSlice)
					)
				),
			keyAccessor: (loc) => loc.id,
			valueAccessor: (loc) => loc.id,
			handleChange:
				(selectOption = FILTER_OPTIONS.IS) =>
				(ids) => {
					updateFilters(
						filterOptionsBuilder(selectOption, 'locationIds', ids),
						targetCollectionName
					);
				},
			targetCollectionName: filterTargetCollectionName,
			fetch: fetchLocations,
			fetchMultiple: () => {},
			renderItem: (loc) => loc.name,
			sortBy: { sort_by: 'name', order: 'ascend' },
			component: RegionsLocationsTreeSelect,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
		{
			label: 'Problem Type',
			mode: 'multiple',
			fieldName: FILTER_CONFIG_NAMES.PROBLEM_TYPE,
			stateSlice: problemTypes,
			filtersValueAccessor: (filtersStateSlice, selectedFilterOption = FILTER_OPTIONS.IS) =>
				changeFilterValueToArrayOfIds(
					nullSafeGet(
						FILTER_OPTION_KEY_BUILDERS[selectedFilterOption](FILTER_CONFIG_NAMES.PROBLEM_TYPE),
						getFilters(filtersStateSlice)
					)
				),
			keyAccessor: (pt) => pt.id,
			valueAccessor: (pt) => pt.id,
			handleChange:
				(selectOption = FILTER_OPTIONS.IS) =>
				(ids) => {
					updateFilters(
						filterOptionsBuilder(selectOption, FILTER_CONFIG_NAMES.PROBLEM_TYPE, ids),
						targetCollectionName
					);
				},
			targetCollectionName: filterTargetCollectionName,
			fetch: fetchProblemTypes,
			fetchMultiple: () => {},
			renderItem: (pt) => pt.name,
			sortBy: { sort_by: 'name', order: 'ascend' },
			component: ProblemTypeTreeSelect,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
	];
};
